export default {
	cancelButton: "Cancel",
	saveButton: "Save",
	title: "New Key Result",
};
